/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_ReferenceInputs */

const en__field_reference = /** @type {(inputs: _Field_ReferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reference`)
};

const de__field_reference = /** @type {(inputs: _Field_ReferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Referenz`)
};

/**
* | output |
* | --- |
* | "Reference" |
*
* @param {_Field_ReferenceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_reference = /** @type {((inputs?: _Field_ReferenceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_ReferenceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_reference(inputs)
	return de__field_reference(inputs)
});